var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button, Tooltip } from 'antd';
import './index.less';
class ToggleButton extends React.Component {
    constructor(props) {
        super(props);
        this._className = `oss-ui-toggle-button`;
        this.pressedClass = 'btn-pressed';
        // Instantiate the state.
        // components state
        this.state = {
            pressed: props.pressed,
            lastClickEvt: null,
            overallPressed: props.pressed,
            isClicked: false,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // 确定props的 pressed是否发生变化
        if (prevState.pressed !== nextProps.pressed) {
            return {
                pressed: nextProps.pressed,
                overallPressed: nextProps.pressed,
                isClicked: false,
                lastClickEvt: null,
            };
        }
        return null;
    }
    componentDidMount() {
        if (this.props.onToggle && this.props.pressed === true) {
            this.props.onToggle(true, null);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { onToggle } = this.props;
        const { pressed, lastClickEvt, overallPressed, isClicked } = this.state;
        let shouldToggle = false;
        if (isClicked || prevState.pressed !== pressed || prevState.isClicked) {
            if (isClicked) {
                // button is clicked
                shouldToggle = true;
            }
            else {
                // check for prop change
                if (pressed !== prevState.overallPressed) {
                    // pressed prop has changed
                    shouldToggle = true;
                }
                else {
                    if (prevState.isClicked) {
                        // prop has not changed but the previous was click event
                        if (prevState.overallPressed !== overallPressed) {
                            shouldToggle = true;
                        }
                    }
                }
            }
            if (shouldToggle && onToggle) {
                onToggle(overallPressed, lastClickEvt);
            }
        }
    }
    onClick(evt) {
        this.setState({
            overallPressed: !this.state.overallPressed,
            lastClickEvt: evt,
            isClicked: true,
        });
    }
    render() {
        const { overallPressed } = this.state;
        const _a = this.props, { className, icon, pressed, onToggle, tooltip, tooltipPlacement, tooltipProps } = _a, antBtnProps = __rest(_a, ["className", "icon", "pressed", "onToggle", "tooltip", "tooltipPlacement", "tooltipProps"]);
        const { onClick } = antBtnProps, filteredAntBtnProps = __rest(antBtnProps, ["onClick"]);
        const finalClassName = className ? `${className} ${this._className}` : this._className;
        let pressedClass = '';
        if (overallPressed) {
            pressedClass = ` ${this.pressedClass} `;
        }
        return (<Tooltip title={tooltip} placement={tooltipPlacement} {...tooltipProps}>
                <Button className={`${finalClassName}${pressedClass}`} onClick={this.onClick.bind(this)} {...filteredAntBtnProps}>
                    {antBtnProps.children}
                </Button>
            </Tooltip>);
    }
}
ToggleButton.defaultProps = {
    type: 'primary',
    pressed: false,
    tooltipProps: {
        mouseEnterDelay: 1.5,
    },
    onToggle: () => undefined,
};
export default ToggleButton;
